import { Brand } from 'common/Brand';
import React from 'react';
import { Link } from 'react-router-dom';
import { LogoProps, ShefLogo } from 'src/pages/consumer/components/header-v2/shared-components/ShefLogo';
import { TableRunLogo, TableRunLogoVariant } from 'src/shared/brand/TableRunLogo';
import { useBrand } from 'src/shared/hooks/useBrand';

/**
 * The brand mark for the current host, for surfaces shared by both brands.
 *
 * On TableRun this links to the storefront root rather than delegating to {@link ShefLogo}, whose
 * destination is computed from the marketplace's meal-plan surfacing logic — that is what sent a
 * TableRun customer clicking the logo into Shef's WSS intake funnel.
 */
export const BrandLogo: React.FC<LogoProps> = ({ height, color }) => {
  const brand = useBrand();

  if (brand === Brand.TableRun) {
    return (
      <Link to='/' data-testid='brand-logo-tablerun'>
        <TableRunLogo variant={TableRunLogoVariant.Compact} />
      </Link>
    );
  }

  return <ShefLogo height={height} color={color} />;
};
